import { render, staticRenderFns } from "./ChangePwdForm.vue?vue&type=template&id=18eb21c7&scoped=true&"
import script from "./ChangePwdForm.vue?vue&type=script&lang=js&"
export * from "./ChangePwdForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePwdForm.vue?vue&type=style&index=0&id=18eb21c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb21c7",
  null
  
)

export default component.exports